<!--
  Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<br/>
<h1 class="page-header">GPS Timing</h1>
<br/>
@if (permission()) {
  <div>
    @if (loading || exporting) {
      <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    }
    <table style="width:100%; height: 100%">
      <tr>
        <td><h3 style="font-size: x-large; font-weight: bold">Timing Chart</h3></td>
        <p-confirmDialog key="missingGpsRposConfirmation"></p-confirmDialog>
        <td></td>
        <td><div class="buttons" style="float: right;">
          @if (adminPermission()) {
            <p-button label="Save All Changes" (click)="saveGpsTimingRows()"
              icon="pi pi-save" [disabled]="!dataChanged || duplicate || rowsInvalid"
            [loading]="!!(saving || exporting || resetting)" class="gm-btn-primary mr-2"></p-button>
          }
          <p-button icon="pi pi-download" (onClick)="exportReport()" [loading]="exporting"
          label="Download Report" class="gm-btn-primary mr-2"></p-button>
          @if (adminPermission()) {
            <p-button label="Reset Changes" (click)="resetChanges()"
              [loading]="!!(saving || exporting || resetting)"
            severity="warn" icon="pi pi-replay"></p-button>
          }
        </div>
      </td>
    </tr>
  </table>
  <ag-grid-angular style="width: 100%; height: 80vh;" class="ag-theme-balham gps-timing"
    [enableCellTextSelection]="true" [undoRedoCellEditing]="true"
    [undoRedoCellEditingLimit]="50"
    (cellEditingStopped)="cellEditingStopped($event, rowData)"
    [columnDefs]="cols" [rowData]="rowDataSignal()"
    [defaultColDef]="defaultColDef" [autoSizeStrategy]="autoSizeStrategy"
    (gridReady)="onGridReady($event); setFilter(); setupCustomFilterStyling();"
    [rowHeight]="60" [paginationPageSize]="1000" [pagination]="true"
    [paginationPageSizeSelector]="[100, 200, 300, 500, 1000]"
  [rowClassRules]="rowClassRules"></ag-grid-angular>
</div>
}







